import { render, staticRenderFns } from "./regionalTimeliness.vue?vue&type=template&id=36efe41a"
import script from "./regionalTimeliness.vue?vue&type=script&lang=js"
export * from "./regionalTimeliness.vue?vue&type=script&lang=js"
import style0 from "./regionalTimeliness.vue?vue&type=style&index=0&id=36efe41a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36efe41a')) {
      api.createRecord('36efe41a', component.options)
    } else {
      api.reload('36efe41a', component.options)
    }
    module.hot.accept("./regionalTimeliness.vue?vue&type=template&id=36efe41a", function () {
      api.rerender('36efe41a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReportManagement/SHEINDailyDeliveryData/components/regionalTimeliness.vue"
export default component.exports